import { render, staticRenderFns } from "./TitoloPage.vue?vue&type=template&id=6173aa68"
import script from "./TitoloPage.vue?vue&type=script&lang=js"
export * from "./TitoloPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports